var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { processResponse, processError, privateRequestParamsCommerce } from '../utils';
import { hasAuthAccessParams } from '../types/guards';
export default class HeroCommerceApi {
    static initAuthToken(accessParams) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!hasAuthAccessParams(accessParams)) {
                throw new Error('private access params missing');
            }
            try {
                const response = yield axios.get(accessParams.API_COMMERCE_HOSTNAME + 'heroauth/init/', privateRequestParamsCommerce(accessParams));
                return processResponse(response);
            }
            catch (error) {
                return processError(error);
            }
        });
    }
    static getPlanCancellationFee(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_COMMERCE_HOSTNAME + 'subscription/cancellation-fee', privateRequestParamsCommerce(accessParams))
            .then((response) => {
            return processResponse(response);
        })
            .catch((error) => {
            return processError(error);
        });
    }
    static changeMembershipPlan(accessParams, key) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_COMMERCE_HOSTNAME + 'subscription/set-plan', { key }, privateRequestParamsCommerce(accessParams))
            .then((response) => {
            return processResponse(response);
        })
            .catch((error) => {
            return processError(error);
        });
    }
    static listPlans(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .get(accessParams.API_COMMERCE_HOSTNAME + 'subscription/list-plans', privateRequestParamsCommerce(accessParams))
            .then((response) => {
            return processResponse(response);
        })
            .catch((error) => {
            return processError(error);
        });
    }
    static paymentUpdate(accessParams, params) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_COMMERCE_HOSTNAME + 'subscription/set-payment', params, privateRequestParamsCommerce(accessParams, { timeout: 90000 }))
            .then((response) => {
            return processResponse(response);
        })
            .catch((error) => {
            return processError(error);
        });
    }
    static fetchOrganizationDetails(accessParams, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!hasAuthAccessParams(accessParams)) {
                throw new Error('private access params missing');
            }
            try {
                const response = yield axios.get(accessParams.API_COMMERCE_HOSTNAME +
                    `organizations/backoffice/organization/?id=${params.id}`, privateRequestParamsCommerce(accessParams));
                return processResponse(response);
            }
            catch (error) {
                return processError(error);
            }
        });
    }
}
//# sourceMappingURL=index.js.map